// extracted by mini-css-extract-plugin
export default {"headerHeight":"82px","accordionHeaderHeight":"78px"};